import { useState } from 'react';
import './TestimonialForm.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const RATING_LABELS = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Very Good', 5: 'Excellent!' };

export default function TestimonialForm() {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [rating, setRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const [story, setStory] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | done | error

  const displayRating = hoverRating || rating;

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim() || !story.trim()) return;
    setStatus('sending');
    try {
      const r = await fetch(`${API_BASE}/api/testimonials`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), company_role: role.trim(), rating, story: story.trim() }),
      });
      if (!r.ok) throw new Error('failed');
      setStatus('done');
      setName(''); setRole(''); setRating(5); setStory('');
    } catch {
      setStatus('error');
    }
  }

  if (status === 'done') {
    return (
      <div className="tf-card tf-done reveal-scale">
        <span className="tf-done-icon">✓</span>
        <h3>Thank You!</h3>
        <p>Your story has been submitted. Our team will review it, and it may be featured on our Testimonials page soon.</p>
        <button type="button" className="tf-again-btn" onClick={() => setStatus('idle')}>Submit Another →</button>
      </div>
    );
  }

  return (
    <div className="tf-wrap">
      <div className="tf-intro reveal-left">
        <span className="tf-badge">✦ Share Your Experience</span>
        <h2>Be Part of Our <em>Growth Story</em></h2>
        <p>Worked with AerialRoot? Tell us how it went — your story helps other Trichy businesses decide with confidence.</p>
      </div>

      <form className="tf-card reveal-right" onSubmit={handleSubmit}>
        <div className="tf-row">
          <div className="tf-field">
            <label>Full Name</label>
            <input type="text" placeholder="e.g. Karthik Raja" value={name} onChange={e => setName(e.target.value)} required maxLength={200} />
          </div>
          <div className="tf-field">
            <label>Company &amp; Role</label>
            <input type="text" placeholder="e.g. Owner, Kolambu Kitchen" value={role} onChange={e => setRole(e.target.value)} maxLength={200} />
          </div>
        </div>

        <div className="tf-field">
          <label>Your Experience Score</label>
          <div className="tf-stars-row">
            {[1, 2, 3, 4, 5].map(n => (
              <button
                type="button"
                key={n}
                className={`tf-star-btn ${n <= displayRating ? 'filled' : ''}`}
                onMouseEnter={() => setHoverRating(n)}
                onMouseLeave={() => setHoverRating(0)}
                onClick={() => setRating(n)}
                aria-label={`${n} star${n > 1 ? 's' : ''}`}
              >★</button>
            ))}
            <span className="tf-rating-label">{displayRating}.0 / 5.0 — {RATING_LABELS[displayRating]}</span>
          </div>
        </div>

        <div className="tf-field">
          <label>Your Story</label>
          <textarea
            placeholder="Tell us how AerialRoot helped your business grow…"
            value={story}
            onChange={e => setStory(e.target.value)}
            required
            maxLength={3000}
            rows={5}
          />
        </div>

        {status === 'error' && <p className="tf-error">Something went wrong — please try again in a moment.</p>}

        <button type="submit" className="tf-submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Submitting…' : 'Submit Your Story →'}
        </button>
      </form>
    </div>
  );
}
